import { ExternalLink } from 'lucide-react';
import { GlassCard } from './ui';
import { useAuthUser } from '../hooks/useAuthUser';
import {
  WEBSITE_ISSUE_SITES,
  websiteIssueUrl,
  type WebsiteIssueSite,
} from '../config/website-issues';

/**
 * Clickable list of the sites staff can report on. Choosing one opens it in a
 * new tab with the Page Feedback annotation widget enabled (guest access) so
 * the reporter can draw right on the page and send it to the web team — no
 * login, no ticket form. Rendered inline in the IT Support form when
 * "Website Issue" is picked as the request type (the former home-page tab
 * was retired in favor of that flow).
 */
export function WebsiteIssueList() {
  const { name, email } = useAuthUser();

  function openSite(site: WebsiteIssueSite) {
    // Pass the signed-in (OneLogin) name so the widget prefills "Your name",
    // and the email so the web team can close the loop when it's fixed.
    window.open(websiteIssueUrl(site, name, email), '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="space-y-3 max-w-md mx-auto">
      {WEBSITE_ISSUE_SITES.map((site) => (
        <button
          key={site.origin}
          type="button"
          onClick={() => openSite(site)}
          className="w-full text-left"
        >
          <GlassCard className="p-5">
            <div className="flex items-center gap-4">
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900">{site.name}</p>
                <p className="text-sm text-gray-500 truncate">{site.description}</p>
              </div>
              <ExternalLink className="w-4 h-4 text-primary flex-shrink-0" />
            </div>
          </GlassCard>
        </button>
      ))}
    </div>
  );
}
